import axios from 'axios';

export default async function checkApiHealth(apiUrl: string): Promise<boolean> {
  try {
    console.log(`Direct API health check at ${apiUrl}/api/health`);
    const response = await axios.get(`${apiUrl}/api/health`, { timeout: 5000 });
    console.log('Direct API health check result: Available');
    return true;
  } catch (error) {
    console.warn('Direct API health check failed:', error);
    return false;
  }
}

// Export an empty object to ensure this file is treated as a module
export const __moduleMarker = {}; 